export const countryCodeToFiCountryName = {
  AC: "Ascension-saari",
  AF: "Afganistan",
  AX: "Ahvenanmaa",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Amerikan Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua ja Barbuda",
  AR: "Argentiina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Itävalta",
  AZ: "Azerbaidžan",
  BS: "Bahama",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Valko-Venäjä",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia ja Hertsegovina",
  BW: "Botswana",
  BV: "Bouvet'nsaari",
  BR: "Brasilia",
  IO: "Brittiläinen Intian valtameren alue",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KY: "Caymansaaret",
  CF: "Keski-Afrikan tasavalta",
  TD: "Tšad",
  CL: "Chile",
  CN: "Kiina",
  CX: "Joulusaari",
  CC: "Kookossaaret",
  CO: "Kolumbia",
  KM: "Komorit",
  CG: "Kongo",
  CD: "Kongon demokraattinen tasavalta",
  CK: "Cookinsaaret",
  CR: "Costa Rica",
  CI: "Norsunluurannikko",
  HR: "Kroatia",
  CU: "Kuuba",
  CY: "Kypros",
  CZ: "Tšekki",
  DK: "Tanska",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikaaninen tasavalta",
  EC: "Ecuador",
  EG: "Egypti",
  SV: "El Salvador",
  GQ: "Päiväntasaajan Guinea",
  ER: "Eritrea",
  EE: "Viro",
  ET: "Etiopia",
  FK: "Falklandinsaaret (Malvinas)",
  FO: "Färsaaret",
  FJ: "Fidži",
  FI: "Suomi",
  FR: "Ranska",
  GF: "Ranskan Guayana",
  PF: "Ranskan Polynesia",
  TF: "Ranskan eteläiset ja antarktiset alueet",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Saksa",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Kreikka",
  GL: "Grönlanti",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard- ja McDonaldinsaaret",
  VA: "Vatikaani",
  HN: "Honduras",
  HK: "Hongkong",
  HU: "Unkari",
  IS: "Islanti",
  IN: "Intia",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlanti",
  IM: "Mansaari",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaika",
  JP: "Japani",
  JE: "Jersey",
  JO: "Jordania",
  KZ: "Kazakstan",
  KE: "Kenia",
  KI: "Kiribati",
  KR: "Korea",
  KP: "Pohjois-Korea",
  KW: "Kuwait",
  KG: "Kirgisia",
  LA: "Laos",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Liettua",
  LU: "Luxemburg",
  MO: "Macao",
  MK: "Makedonia",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malesia",
  MV: "Malediivit",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshallinsaaret",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Meksiko",
  FM: "Mikronesia",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Alankomaat",
  AN: "Alankomaiden Antillit",
  NC: "Uusi-Kaledonia",
  NZ: "Uusi-Seelanti",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkinsaari",
  MP: "Pohjois-Mariaanit",
  NO: "Norja",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestiina",
  PA: "Panama",
  PG: "Papua-Uusi-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippiinit",
  PN: "Pitcairn",
  PL: "Puola",
  PT: "Portugali",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Venäjä",
  RW: "Ruanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts ja Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre ja Miquelon",
  VC: "Saint Vincent ja Grenadiinit",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé ja Príncipe",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychellit",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Salomonsaaret",
  SO: "Somalia",
  ZA: "Etelä-Afrikka",
  GS: "Etelä-Georgia ja Eteläiset Sandwichsaaret",
  ES: "Espanja",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Huippuvuoret ja Jan Mayen",
  SZ: "Swazimaa",
  SE: "Ruotsi",
  CH: "Sveitsi",
  SY: "Syyria",
  TW: "Taiwan",
  TJ: "Tadžikistan",
  TZ: "Tansania",
  TH: "Thaimaa",
  TL: "Itä-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad ja Tobago",
  TA: "Tristan da Cunha",
  TN: "Tunisia",
  TR: "Turkki",
  TM: "Turkmenistan",
  TC: "Turks- ja Caicossaaret",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Arabiemiirikunnat",
  GB: "Iso-Britannia",
  US: "Yhdysvallat",
  UM: "Yhdysvaltain erillissaaret",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Brittiläiset Neitsytsaaret",
  VI: "Yhdysvaltain Neitsytsaaret",
  WF: "Wallis ja Futuna",
  EH: "Länsi-Sahara",
  YE: "Jemen",
  ZM: "Sambia",
  ZW: "Zimbabwe",
  BQ: "Bonaire, Sint Eustatius ja Saba",
  CW: "Curaçao",
  SS: "Etelä-Sudan",
  SX: "Sint Maarten (hollantilainen osa)",
  XK: "Kosovo"
};
